<script setup lang="ts">
import { createKey } from '@/utils'
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';
import { navigateTo } from './utils/page';
import { PageEnum } from './enums/pageEnum';
const route = useRoute();
const key = createKey(route.path);

onMounted(() => {
    // settleAppInfo();
    // document.addEventListener('touchmove', function (event) {
    //     event.preventDefault();
    // }, { passive: false });

    // 刷新动作返回首页
    if (sessionStorage.getItem('isFirst')) {
        navigateTo({ name: PageEnum.COVER });
    } else {
        sessionStorage.setItem('isFirst', '1');
    }
});
</script>

<template>
    <RouterView :key="key" />
</template>
<style>
:root {
    --van-toast-text-color: black;
    --van-toast-background: white;
}

.van-toast--text {
    background: white !important;
}

.van-toast__text {
    color: black;
}
</style>